import * as React from 'react';

import classnames from 'classnames';

import styles from './sidebar-drawer.module.css';

type Props = {
    children?: React.ReactNode;
    headerText?: string;
    customHeader?: React.ReactElement<any>;
    smallHeader?: boolean;
    hasNoTopPadding?: boolean;
};

export class SidebarDrawer extends React.PureComponent<Props> {
    render() {
        const drawerContentsStyleNames = classnames({
            [styles['drawer-contents']]: true,
            [styles['drawer-contents--with-header']]:
                this.props.customHeader || this.props.headerText,
            [styles['drawer-contents--small-header']]: this.props.smallHeader,
            [styles['drawer-contents--no-top-padding']]: this.props.hasNoTopPadding,
        });

        return (
            <div className={styles['sidebar-drawer']}>
                <div className={styles['drawer-container']}>
                    {this.props.headerText ? (
                        <>
                            <div className={styles.header}>
                                <div className={styles['header-text']}>{this.props.headerText}</div>
                            </div>
                            <div className={styles.bar} />
                        </>
                    ) : undefined}
                    {this.props.customHeader ? (
                        <div className={styles.header}>{this.props.customHeader}</div>
                    ) : undefined}
                    <div className={drawerContentsStyleNames}>{this.props.children}</div>
                </div>
            </div>
        );
    }
}
